import { IPage } from "../Pages/model";

export interface IRoleForm {
  id?: number,
  name: string,
  description?: string,
  permissions?: IPage[]
  require_Branch: boolean;
  require_Document_Upload_Us_Company: boolean;
  require_Document_Upload_Payroll_Company: boolean;
}



export const defaultRoleForm: IRoleForm = {
  id: 0,
  name: "",
  description: "",
  permissions: [],
  require_Branch: false,
  require_Document_Upload_Us_Company: false,
  require_Document_Upload_Payroll_Company: false
};